import type { FooterButtonTypes } from './FooterButton.types';

import * as hotkeys from 'constants/hotkeys';

export const FOOTER_BUTTON_HTMLS: Record<FooterButtonTypes, string> = {
  next: '<span class="hotkey">N</span>ext',
  prev: '<span class="hotkey">P</span>revious',
  navigator: 'Na<span class="hotkey">v</span>igator',
  end_exam: '<span class="hotkey">E</span>nd Exam',
  end_section: '<span class="hotkey">E</span>nd Section',
  end_review: '<span class="hotkey">E</span>nd Review',
  review_screen: 'Re<span class="hotkey">v</span>iew Screen',
  review_all: 'Review <span class="hotkey">A</span>ll',
  review_incomplete: 'Review <span class="hotkey">I</span>ncomplete',
  review_flagged: 'Re<span class="hotkey">v</span>iew Flagged',
  return_overview: '<span class="hotkey">R</span>eturn to Overview',
  report: '<span class="hotkey">R</span>eport Question',
};

export const FOOTER_BUTTON_HOTKEYS: Record<FooterButtonTypes, string> = {
  next: hotkeys.NEXT,
  prev: hotkeys.PREV,
  navigator: hotkeys.NAVIGATOR,
  end_exam: hotkeys.END_EXAM,
  end_section: hotkeys.END_SECTION,
  end_review: hotkeys.END_REVIEW,
  review_screen: hotkeys.NAVIGATOR,
  review_all: hotkeys.REVIEW_ALL,
  review_incomplete: hotkeys.REVIEW_INCOMPLETE,
  review_flagged: hotkeys.REVIEW_FLAGGED,
  return_overview: hotkeys.RETURN_OVERVIEW,
  report: hotkeys.REPORTS,
};
